import { MandatoryAccountModal } from 'components/MandatoryAccountModal/MandatoryAccountModal';
import { Nothing } from 'components/Nothing/Nothing';
import {
  FF_MANDATORY_ACCOUNT_CHINA,
  FF_MANDATORY_ACCOUNT_CHINA_VERSION,
  FF_MANDATORY_ACCOUNT_INDIA,
  FF_MANDATORY_ACCOUNT_INDIA_VERSION,
  PAYEX_PLATFORM,
} from 'constants/index';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { useSelector } from 'react-redux';
import {
  getPlatform,
  isPayingFromChina,
  isPayingFromIndia,
  isUserCreated,
  paymentIsFromAgents,
} from 'selectors';
import { getTestVariant } from 'utils/getTestVariant/getTestVariant';

const REFETCH_TIMEOUT = 60000;

const MandatoryAccount = () => {
  const payingFromIndia = useSelector(isPayingFromIndia);
  const payingFromChina = useSelector(isPayingFromChina);
  const isFromAgents = useSelector(paymentIsFromAgents);
  const isPayexPlatform = useSelector(getPlatform) === PAYEX_PLATFORM;
  const userCreated = useSelector(isUserCreated);
  const showSignupTab = !userCreated;

  const eligibility = {
    india: !isFromAgents && isPayexPlatform && payingFromIndia,
    china: !isFromAgents && isPayexPlatform && payingFromChina,
  };

  const { data: featureFlags } = usePeertransferFlags(
    [
      FF_MANDATORY_ACCOUNT_INDIA,
      FF_MANDATORY_ACCOUNT_INDIA_VERSION,
      FF_MANDATORY_ACCOUNT_CHINA,
      FF_MANDATORY_ACCOUNT_CHINA_VERSION,
    ],
    {
      refetchInterval: REFETCH_TIMEOUT,
      enabled: eligibility.india || eligibility.china,
    },
  );

  const testVariants = {
    india: getTestVariant(
      featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA] ?? false,
      featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA_VERSION] ?? false,
    ),
    china: getTestVariant(
      featureFlags?.[FF_MANDATORY_ACCOUNT_CHINA] ?? false,
      featureFlags?.[FF_MANDATORY_ACCOUNT_CHINA_VERSION] ?? false,
    ),
  };

  const activeModal =
    (eligibility.india && testVariants.india === 'C') ||
    (eligibility.china && testVariants.china === 'C');

  return activeModal ? (
    <MandatoryAccountModal showSignupTab={showSignupTab} />
  ) : (
    <Nothing />
  );
};

export { MandatoryAccount };
